import {
  useBuildSignUpUrl,
  usePerfBuildSignUpUrl,
} from "@faire/retailer-visitor-shared/components/AppSignUp/useBuildSignUpURL";
import { useSettingPrefetchSignUpIframe } from "@faire/retailer-visitor-shared/settings/useSettingPrefetchSignUpIframe";
import { useSettingSignUpSplit } from "@faire/retailer-visitor-shared/settings/useSettingSignUpSplit";
import { useInjectIframePrefetchCallback } from "@faire/retailer-visitor-shared/views/SignUp/_hooks/useInjectIframePrefetch";
import { useCallback } from "react";

export const useSignUpInjectIframePrefetch = () => {
  const isSignUpSplitEnabled = useSettingSignUpSplit();
  const isPrefetchSignUpIframeEnabled = useSettingPrefetchSignUpIframe();
  const signUpUrl = useBuildSignUpUrl();
  const injectIframePrefetchCallback =
    useInjectIframePrefetchCallback(signUpUrl);

  return useCallback(() => {
    injectIframePrefetchCallback(
      !isPrefetchSignUpIframeEnabled || !isSignUpSplitEnabled
    );
  }, [
    isPrefetchSignUpIframeEnabled,
    isSignUpSplitEnabled,
    injectIframePrefetchCallback,
  ]);
};

// Doesn't support Faire Direct signup query params
export const usePerfSignUpInjectIframePrefetch = (location: {
  pathname: string;
  search: string;
}) => {
  const isPrefetchSignUpIframeEnabled = useSettingPrefetchSignUpIframe();
  const isSignUpSplitEnabled = useSettingSignUpSplit();
  const signUpUrl = usePerfBuildSignUpUrl(location);
  const injectIframePrefetchCallback =
    useInjectIframePrefetchCallback(signUpUrl);

  return useCallback(() => {
    injectIframePrefetchCallback(
      !isPrefetchSignUpIframeEnabled || !isSignUpSplitEnabled
    );
  }, [
    isPrefetchSignUpIframeEnabled,
    isSignUpSplitEnabled,
    injectIframePrefetchCallback,
  ]);
};
